import { typeClouds } from '@/utils/common/hypervisor'
import i18n from '@/locales'

export const providerMap = typeClouds.getProviderlowcase()
const aliyunLogo = require('../../../src/assets/images/providers/aliyun.svg')
const awsLogo = require('../../../src/assets/images/providers/aws.svg')
const azureLogo = require('../../../src/assets/images/providers/azure.svg')
const huaweiLogo = require('../../../src/assets/images/providers/huawei.svg')
const qcloudLogo = require('../../../src/assets/images/providers/qcloud.svg')
const ucloudLogo = require('../../../src/assets/images/providers/ucloud.svg')
const vmwareLogo = require('../../../src/assets/images/providers/vmware.svg')
const openstackLogo = require('../../../src/assets/images/providers/openstack.svg')
// const dstackLogo = require('../../../src/assets/images/providers/dstack.svg')
const zstackLogo = require('../../../src/assets/images/providers/zstack.svg')
const s3Logo = require('../../../src/assets/images/providers/s3.svg')
const cephLogo = require('../../../src/assets/images/providers/ceph.svg')
const xskyLogo = require('../../../src/assets/images/providers/xsky.svg')
const googleLogo = require('../../../src/assets/images/providers/gcp.svg')
const ctyunLogo = require('../../../src/assets/images/providers/tianyi.svg')
const k8sLogo = require('../../../src/assets/images/providers/k8s2.svg')
const serverLogo = require('../../../src/assets/images/providers/server.svg')
const oneCloudLogo = require('../../../src/assets/images/providers/onecloud.svg')
const lbLogo = require('../../../src/assets/images/providers/lb.svg')
const apsaraLogo = require('../../../src/assets/images/providers/apsara.svg')

export const CLOUDACCOUNT_ENVS = ['public', 'private', 'storage', 'vmware']
export const ENVS = ['onecloud', 'public', 'private', 'storage', 'container']
export const ENV_TITLE = {
  onecloud: i18n.t('scope.text_74'),
  public: i18n.t('scope.text_75'),
  private: i18n.t('scope.text_76'),
  storage: i18n.t('scope.text_77'),
  container: i18n.t('scope.text_78'),
}

const PHY_URL = '/physicalmachine'
const CLUSTERS = '/k8s-cluster'
const BUCKET_URL = '/bucket'
export const vm_url = '/vminstance'
export const cloudaccount_create_url = '/cloudaccount'
export const ENV_FORMS = {
  public: ['Cloundacount', 'Iso', vm_url],
  onestack: ['Region', 'Zone', 'Wire', 'Network', 'Host', 'Storage', 'ShareStorage', 'Iso', vm_url],
  onecloud: ['Region', 'Zone', 'Wire', 'Network', 'Host', 'Storage', 'ShareStorage', 'Iso', cloudaccount_create_url],
  baremetal: ['Region', 'Zone', 'Wire', 'Network', 'Iso', PHY_URL],
  container: ['Region', 'Zone', 'Wire', 'Network', 'Iso', CLUSTERS],
  vmware: ['Cloundacount', 'Region', 'Zone', 'Wire', 'Network', 'Iso', vm_url],
  private: ['Cloundacount', 'Iso', vm_url],
  s3: ['Cloundacount', BUCKET_URL],
}
export const ENV_FORMS_CONFIG = {
  [vm_url]: {
    title: i18n.t('scope.text_49'),
    icon: 'blank',
  },
  [PHY_URL]: {
    title: i18n.t('scope.text_44'),
    icon: 'blank',
  },
  [CLUSTERS]: {
    title: i18n.t('scope.text_79'),
    icon: 'blank',
  },
  [BUCKET_URL]: {
    title: i18n.t('scope.text_77'),
    icon: 'blank',
  },
  [cloudaccount_create_url]: {
    title: i18n.t('scope.text_80'),
    icon: 'blank',
  },
  Cloundacount: {
    title: i18n.t('scope.text_80'),
  },
  Iso: {
    title: i18n.t('scope.text_81'),
    helpMessages: [
      i18n.t('scope.text_82'),
      i18n.t('scope.text_83'),
      i18n.t('scope.text_84'),
      i18n.t('scope.text_85'),
      // '容器管理必须选择 k8s-centos7-base.qcow2 镜像。',
    ],
  },
  Region: {
    title: i18n.t('scope.text_70'),
    helpMessages: [
      i18n.t('scope.text_86'),
      i18n.t('scope.text_87'),
    ],
  },
  Zone: {
    title: i18n.t('scope.text_22'),
    helpMessages: [
      i18n.t('scope.text_88'),
      i18n.t('scope.text_89'),
      i18n.t('scope.text_90'),
    ],
  },
  Wire: {
    title: i18n.t('scope.text_41'),
    helpMessages: [
      i18n.t('scope.text_91'),
      i18n.t('scope.text_92'),
      i18n.t('scope.text_93'),
    ],
  },
  Network: {
    title: i18n.t('scope.text_43'),
    helpMessages: [
      i18n.t('scope.text_94'),
      i18n.t('scope.text_95'),
    ],
  },
  Host: {
    title: i18n.t('scope.text_60'),
    helpMessages: [
      i18n.t('scope.text_96'),
      i18n.t('scope.text_97'),
    ],
  },
  Storage: {
    title: i18n.t('scope.text_98'),
    helpMessages: [
      i18n.t('scope.text_99'),
      i18n.t('scope.text_100'),
    ],
  },
  ShareStorage: {
    title: i18n.t('scope.text_101'),
    helpMessages: [
      i18n.t('scope.text_102'),
      i18n.t('scope.text_103'),
    ],
  },
}

export const SUB_EBV_ITMS = {
  onecloud: {
    onestack: {
      name: 'KVM',
      logo: oneCloudLogo,
      provider: providerMap.onecloud.key,
    },
    baremetal: {
      name: i18n.t('scope.text_104'),
      logo: serverLogo,
      // component: 'CtyunCreate',
      // provider: providerMap.ctyun.key,
    },
    lb: {
      name: i18n.t('scope.text_105'),
      logo: lbLogo,
      // component: 'CtyunCreate',
      // provider: providerMap.ctyun.key,
    },
  },
  public: {
    aliyun: {
      name: providerMap.aliyun.label,
      logo: aliyunLogo,
      component: 'AliyunCreate',
      provider: providerMap.aliyun.key,
    },
    aws: {
      name: providerMap.aws.label,
      logo: awsLogo,
      component: 'AwsCreate',
      provider: providerMap.aws.key,
    },
    azure: {
      name: providerMap.azure.label,
      logo: azureLogo,
      component: 'AzureCreate',
      provider: providerMap.azure.key,
    },
    huawei: {
      name: providerMap.huawei.label,
      logo: huaweiLogo,
      component: 'HuaweiCreate',
      provider: providerMap.huawei.key,
    },
    qcloud: {
      name: providerMap.qcloud.label,
      logo: qcloudLogo,
      component: 'QcloudCreate',
      provider: providerMap.qcloud.key,
    },
    ucloud: {
      name: providerMap.ucloud.label,
      logo: ucloudLogo,
      component: 'UcloudCreate',
      provider: providerMap.ucloud.key,
    },
    google: {
      name: providerMap.google.label,
      logo: googleLogo,
      component: 'GoogleCreate',
      provider: providerMap.google.key,
    },
    ctyun: {
      name: providerMap.ctyun.label,
      logo: ctyunLogo,
      component: 'CtyunCreate',
      provider: providerMap.ctyun.key,
    },
  },
  private: {
    vmware: {
      name: 'VMWare',
      logo: vmwareLogo,
      component: 'VMwareCreate',
      provider: providerMap.vmware.key,
    },
    openstack: {
      name: providerMap.openstack.label,
      logo: openstackLogo,
      component: 'OpenstackCreate',
      provider: providerMap.openstack.key,
    },
    // dstack: {
    //   name: providerMap.dstack.label,
    //   logo: dstackLogo,
    //   component: 'DstackCreate',
    //   provider: providerMap.dstack.key,
    // },
    zstack: {
      name: providerMap.zstack.label,
      logo: zstackLogo,
      component: 'ZstackCreate',
      provider: providerMap.zstack.key,
    },
    apsara: {
      name: providerMap.apsara.label,
      logo: apsaraLogo,
      component: 'ApsaraCreate',
      provider: providerMap.apsara.key,
    },
  },
  container: {
    k8s: {
      logo: k8sLogo,
      logoStyle: {
        width: '105px',
      },
    },
  },
  storage: {
    s3: {
      name: providerMap.s3.label,
      logo: s3Logo,
      component: 'S3Create',
      provider: providerMap.s3.key,
    },
    ceph: {
      name: providerMap.ceph.label,
      logo: cephLogo,
      component: 'CephCreate',
      provider: providerMap.ceph.key,
    },
    xsky: {
      name: providerMap.xsky.label,
      logo: xskyLogo,
      component: 'XskyCreate',
      provider: providerMap.xsky.key,
      hiddenName: true,
      logoStyle: {
        width: '60px',
      },
    },
  },
}
